import React, { useState } from 'react'
import PasswordField from '../elements/form/PasswordField'
import { useDispatch } from 'react-redux'
import { ERROR, SET_SUCCESS } from '../../store/types'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import FormButton from '../elements/form/FormButton'
import { authHeader } from '../../utils'

const ChangePassword = () => {
    const dispatch = useDispatch()
    const [validationErrors, setValidationErrors] = useState({})  
    const [oldPassword, setOldPassword] = useState('');
    const [password, setPassword] = useState();
    const navigate = useNavigate()
    const validateForm = () => {
        let errors = {}

        if(!oldPassword || oldPassword === '') {
            errors.oldPassword = true
        }

        if(!password || password === '') {
            errors.password = true
        }
        setValidationErrors(errors)

        return errors
    }
    const [processing, setProcessing] = useState(false);
    const createPassword = async  () => {
        const headers = authHeader()
        
        if (Object.values(validateForm()).includes(true)) {

            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        setProcessing(true)

        const requestPayload = { 
            password: oldPassword,
            newPassword: password
        }
        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/change-password`, requestPayload, { headers })  
            
            dispatch({
                type: SET_SUCCESS,
                payload: 'New password created successfully. You will be logged out...'
            })
            setTimeout(() => {
                logout()
            }, 3000);
                      

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    const logout = async () => {
        try {
            const headers = authHeader()
            await axios.delete(`${process.env.REACT_APP_BASE_URL}/auth/sessions`, { headers })            

            localStorage.removeItem("userDetails");
            localStorage.removeItem("authToken");

            navigate("/")
            
        } catch (error) {
            dispatch({
                type: ERROR,
                error
            })
        }
    }
    return (
        <div>
            <p className='text-[13px] text-gray-500'>Please provide your current password and your new password to change your password. If this is successful, you will be logged out, so you can log in with your new password</p>
            <div className='w-full mt-[10px]'>
                <PasswordField
                    inputLabel="Current Password" 
                    fieldId="password" 
                    inputType="password" 
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.oldPassword} 
                    returnFieldValue={(value)=>{setOldPassword(value)}}
                    showPasswordMeter={false}
                />
            </div>
            <div className='w-full mt-[10px]'>
                <PasswordField
                    inputLabel="Password" 
                    fieldId="password" 
                    inputType="password" 
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.password} 
                    returnFieldValue={(value)=>{setPassword(value)}}
                    showPasswordMeter={true}
                />
            </div>

            <div className='mt-8'>
                <FormButton buttonLabel="Change password" buttonAction={()=>{createPassword()}} processing={processing} />
            </div>
        </div>
    )
}

export default ChangePassword